export default __webpack_public_path__ + "static/media/about-mini.ebe71a73.webp";